import React, { useState } from 'react'
import GetIcon from "../../../utils/Icon";
import printerimg from "../../../assets/print.png"
import Button from "../../../Core/Button/Button";
import FormLayoutTwo from '../../../Core/Layout/FormLayoutTwo';
import GeneralDetailsTab1 from './Tabs/GeneralDetailsTab1';
import { usePageState } from "../../../Hook/usePageState";
import { useNavigate } from 'react-router-dom';

function CreateOldGoldEntryForm() {
    const navigate = useNavigate()
    const pageStateDefault = {
        tab1: 1,
        posting_date: '',
        status: '',
        company: '',
        sales_person: '',
        customer: '',
        remarks : '',
        mode_of_payment :'',
        paid_amount : '',
        account_paid_to : '',
        gross_weigh : '',
        image : '',

    };
    const [activeTab, setActiveTab] = useState('tab1');
    const [pageState, setPageState] = usePageState("Create Customer Entry", pageStateDefault);
    const { tab1,
        naming_series,
        company,
        melt_by,
        melt_authorized,
        sales_person,
        old_gold,
        in_stock_item,
    } = pageState;

    const ItemColumnsTab1Table1 = [
        { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
        { title: "Sl.No", field: "sl_no", width: "15px", align: "center" },
        { title: "Old Gold", field: "old_gold", width: "35%" },
        { title: "Weight", field: "weight", width: "45%" },

    ];
    const ItemColumnsTab1Table2 = [
        { title: "Action", field: "action", width: "20px", align: "center", type: "checkbox" },
        { title: "Sl.No", field: "sl_no", width: "15px", align: "center" },
        { title: "Serial No", field: "serial_no", width: "35%" },
        { title: "Item Code", field: "item_code", width: "45%" },
        { title: "Weight", field: "weight", width: "45%" },


    ];

    const additionalData = {
        tab1: {
            compnay: [{ "name": 'Malabar gold and diamonds' }],
            customer_types: [{ "name": 'Regular' }, { "name": 'VIP' }, { "name": 'Wholesale' }],
            assigned_to: [{ "name": 'Akash' }, { "name": 'Ajay' }, { "name": 'Sooraj' }],
            helped_by: [{ "name": 'Megha' }, { "name": 'Sulekha' }, { "name": 'Rahul' }],
            ItemColumnsTab1Table1: ItemColumnsTab1Table1,
            ItemColumnsTab1Table2:ItemColumnsTab1Table2
        },

    };

    const tabs = [
        { id: 'tab1', label: 'General Details', component: GeneralDetailsTab1 },
    ];

    const updateTab1 = (field, value) => {
        console.log(field, value, "check_field_value");

        setPageState({ ...pageState, [field]: value });
    };
    const resetTab1 = () => setPageState({
        customerName: '', email: '', phone: '', dateOfBirth: '', gender: '', occupation: ''
    });
    const resetAll = () => {
        resetTab1();
    };

    const handleSubmit = () => {
        const allData = {
            basicInfo: pageState,
            // companyInfo: tab2Data
        };
        console.log('Submitting:', allData);
    };
    const getCurrentTabInfo = () => {
        switch (activeTab) {
            case 'tab1':
                return {
                    component: GeneralDetailsTab1,
                    data: pageState,
                    onChange: updateTab1,
                    extraData: additionalData.tab1
                };
            default:
                return null;
        }
    };

    const currentTab = getCurrentTabInfo();
    const CurrentComponent = currentTab?.component;

    return (
        <FormLayoutTwo
            title="New Old Gold Entry "
            breadcrumbs={[
                { label: "Old Gold Entry List", url: "/oldgold/old-gold-entry-list" },
            ]}
            status={'New'}
            actionButtons={
                <>  <Button
                    className="custom-btn-00989"
                    iconName="LuFilePlus2"
                    onClick={handleSubmit}
                    iconSize={12}>
                    Save
                </Button>
                    <Button
                        to="/brand/create-brand"
                        className="px-2"
                        imgSrc={printerimg}
                        imgStyle={{ width: '21px' }} />
                </>
            }
        >
            <div style={{ width: "100%", overflow: "hidden", backgroundColor: "#efefef", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end">
                        <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                            {tabs.map((tab) => (
                                <li key={tab.id} className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                    <a className={`removeborder234 nav-link ${activeTab === tab.id
                                        ? 'active-tab-custom-new text-white'
                                        : 'tab-inactive-custom'
                                        } border-radius-top-corner`}
                                        onClick={() => setActiveTab(tab.id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {tab.label}
                                        <GetIcon iconName={activeTab === tab.id ? "MdKeyboardArrowDown" : "MdKeyboardArrowRight"} size={15} />
                                    </a>
                                </li>
                            ))}
                        </ul>
                        <div className="d-flex align-items-center mb-2 px-3">
                            <GetIcon iconName="CgAttachment" size={12} />
                            <span className="fw-semibold ms-1" style={{ color: "#4B002B", fontSize: '12px', cursor: 'pointer' }}>
                                Attachments
                            </span>
                        </div>
                    </div>
                </div>
                <div className=" " style={{ background: '' }}>
                    <div className="row">
                        <div className="col-12">
                            <div >
                                {CurrentComponent && currentTab && (
                                    <CurrentComponent
                                        formData={currentTab.data}
                                        onFieldChange={currentTab.onChange}
                                        extraData={currentTab.extraData}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </FormLayoutTwo>
    )
}

export default CreateOldGoldEntryForm